<template lang="pug">
  div.mb-3
    b-input-group(size="sm" )
      b-form-input(size="sm" type="search", placeholder="Buscar variable...", v-model="filter")
      b-input-group-append
        b-input-group-text
          search-icon.icon-sm
    .text-right.mb-2
      b-link.text-sm(@click="getUserAttributes", :disable="loading")
        refresh-cw-icon.icon-sm.mr-2
        span Actualizar
    b-table.card-table.scrollable-area.max-h-250.mb-0(:items="parsed_attributes", :fields="fields", responsive, show-empty, :filter="filter", :busy="loading", small, empty-text="No hay atributos", empty-filtered-text="No se encontraron atributos" )
      template(v-slot:cell(value)="{ item }")
        b-link.d-flex.align-items-center(href="#", v-if="item.is_image", @click="show_image = item.value; image_modal = true")
          span.mr-1 Ver imagen
          external-link-icon.icon-sm
        b-link.d-flex.align-items-center(href="#", v-else-if="item.value && item.value.length >= 50", @click="showFullText(item.value)")
          span.mr-1 Ver variable
          external-link-icon.icon-sm
        span(v-else) {{ item.value }}
      template(v-slot:table-busy)
        .text-center
          b-spinner(variant="primary")
    b-modal(v-model="image_modal", centered, size="lg", hide-footer, hide-header, @hidden="show_image = null")
      b-container.text-center(fluid)
        b-img(fluid-grow, :src="show_image")
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  const accountController = createNamespacedHelpers('account')

  export default {
    data () {
      return {
        loading: false,
        fields: [
          {
            key: 'name',
            label: 'Variable'
          },
          {
            key: 'value',
            label: 'Valor'
          }
        ],
        attributes: [],
        filter: '',
        image_modal: false,
        show_image: null
      }
    },
    props: {
      platform : {
        type: String,
        default: ''
      }
    },
    computed: {
      ...accountController.mapState({
        user_attributes: state => state.user_attributes,
        user_attributes_values: state => state.user_attributes_values
      }),
      parsed_attributes () {
        let self = this
        return  this.attributes.map(uav => {
          let attr = self.user_attributes.find(ua => { return ua.user_attribute_id == uav.user_attribute_id})
          if (attr && attr.is_important) {
            return {
              name: attr.name,
              type: attr.type,
              value: uav.value,
              is_image: attr.type === 'text' && !!uav.value.match(/(https?:\/\/.*\.(?:png|jpg|jpeg|gif|png|svg))/i)
            }
          } else {
            return null
          }
        }).filter(i => i != null)
      }
    },
    methods: {
      ...mapActions(['account/userAttributes']),
      getUserAttributes () {
        let self = this
        this.loading = true

        this['account/userAttributes']({
          account_id: self.$route.params.account_id,
          callback: res => {
            self.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$emit('update:values')
            }
          }
        })
      },
      showFullText (full_text) {
        let json

        try {
          try {
            json = JSON.parse(full_text)
            json = JSON.stringify(json, null, 2)
          } catch (e) {
            json = full_text
          }

          let x = window.open();
          x.document.open();
          x.document.write('<html><body><pre>' + json + '</pre></body></html>');
          x.document.close();
        } catch (e) {
          console.error(e.message)
          this.$message.warning('No logramos mostrar la variable, por favor comprueba tu conexión a internet')
        }
      },
      showImage (url) {
        try {
          let title = ''
          try {
            title = decodeURIComponent(url.match(/\.com\/.+\.\w{3,4}/gmi)[0].split('/').slice(-1)[0])
          } catch (e) {
            console.log(e.message)
            title = 'Iamgen'
          }
          let x = window.open();
          x.document.open();
          x.document.write(`<html style="height: 100%;">
                              <head>
                                <meta name="viewport" content="width=device-width, minimum-scale=0.1">
                                  <title>${title}</title>
                              </head>
                              <body style="margin: 0px; background: #0e0e0e; height: 100%;">
                                <img style="-webkit-user-select: none;margin: auto;" src=${url}>
                              </body>
                            </html>`);
          x.document.close();
        } catch (e) {
          console.error(e.message)
          this.$message.warning('No logramos mostrar la imagen, por favor comprueba tu conexión a internet')
        }
      }
    },
    watch: {
      user_attributes_values (val) {
        if(val && val[this.platform]){
          this.attributes = val[this.platform].User_Attribute_Values
        }
      }
    },
    components: {  }
  }
</script>

<style lang="scss" scoped>
  .max-h-250 {
    max-height: 250px;
  }
</style>
